import React, { useState, useCallback, useMemo } from "react";
import GenericRoutesList from "components/Routes/GenericRoutesList";
import RouteFilters from "components/Routes/RouteFilters";
import { ROUTE_CONFIGS } from "config/routeConfigs";
import { Box } from "@material-ui/core";
import moment from "moment";

const ArchiveRoutes = () => {
  const config = ROUTE_CONFIGS.archived;
  const [filters, setFilters] = useState({
    dateRange: {
      startDate: null,
      endDate: null
    },
    tourIds: [],
    departures: []
  });

  const filterParams = useMemo(() => {
    const params = {};

    if (filters.dateRange.startDate && filters.dateRange.endDate) {
      params.start_date_from = moment(filters.dateRange.startDate).format('YYYY-MM-DD');
      params.start_date_to = moment(filters.dateRange.endDate).format('YYYY-MM-DD');
    }

    if (filters.tourIds && filters.tourIds.length > 0) {
      params.tour_ids = filters.tourIds;
    }

    if (filters.departures && filters.departures.length > 0) {
      params.departures = filters.departures;
    }

    return params;
  }, [filters]);

  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
  }, []);

  return (
    <GenericRoutesList
      routeType="archived"
      columnsConfig={config.columns}
      mapPath={config.mapPath}
      features={config.features}
      selector={config.selector}
      paginationSelector={config.paginationSelector}
      loadAction={config.loadAction}
      filterParams={filterParams}
      renderFilters={() => (
        <Box mb={2}>
          <RouteFilters value={filters} onChange={handleFilterChange} />
        </Box>
      )}
    />
  );
};

export default ArchiveRoutes;